// UAT
const key = "ofm3yorsf3dryj4pqxsg7ep5fsiowtsgi9rdva0t4rq8c5gc";
//PROD
// const key = "s2p3w6fra94s3i2x707zx0k7g2zqj5ehhpuc1s6mig9ikiqt";
export default key;